{
  "production": false,
  "apiBase": "https://dev.rightbridge.net/api/basev2/api/v3",
  "rixtremaBase": "https://www.larkspurweb.com/PS2/AJAXPS.aspx",
  "f5500Base": "https://f5500-qa.rightbridge.net/api",
  "cannexBase": "https://cannex-dev.rightbridge.net/api",
  "aiBase": "wss://ai-dev.rightbridge.net/ws",
  "basePath": "/app/",
  "assets": null,
  "env": "dev",
  "defaultApp": "rb",
  "org": "basev2",
  "firm": null
}
